const AfrusForm = {
  isComponent: el => el.tagName === 'DIV' && el.classList.contains('afrus-form'),
  model: {
    defaults: Object.assign({}, {
      tagName: 'div',
      removable: true,
      draggable: true,
      droppable: false,
      attributes: {
        id: 'afrus-container-form',
        'attr-type': '1',
        'data-form': null
      },
      traits: model => [
        {
          name: 'attr-type',
          label: 'Type',
          placeholder: 'Type',
          type: 'select',
          options: [
            { id: '1', name: 'Lead forms' },
            { id: '9', name: 'Advanced lead forms' },
            { id: '2', name: 'Domation forms' }
          ]
        },
        {
          name: 'data-form',
          label: 'Form',
          placeholder: 'Form',
          type: 'select',
          options: []
        }
      ]
    }),
    init() {
      this.on('change:attributes:attr-type', this.handleTypeChange)
      this.on('change:attributes:data-form', this.handleFormChange)
    },
    handleTypeChange() {
      const type = this.getAttributes()['attr-type']
      this.setAttributes({
        'attr-type': type,
        'data-form': null
      })
      this.getTrait('data-form').set('options', [])
    },
    handleFormChange() {
      this.setId('afrus-container-form')
      that.loadAfrusScript()
    }
  }
}

export default AfrusForm
